import { useEffect, useState } from 'react';

interface ScrollPosition {
    x: number;
    y: number;
    direction: 'up' | 'down' | null;
}

export const useScrollAnimation = () => {
    const [scrollPosition, setScrollPosition] = useState<ScrollPosition>({
        x: 0,
        y: 0,
        direction: null,
    });
    const [isScrolling, setIsScrolling] = useState(false);
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        let lastScrollY = window.scrollY;
        let ticking = false;
        let scrollTimeout: NodeJS.Timeout;

        const updateScrollPosition = () => {
            const currentScrollY = window.scrollY;
            const currentScrollX = window.scrollX;
            const direction = currentScrollY > lastScrollY ? 'down' : 'up';

            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            const maxScroll = documentHeight - windowHeight;
            const progress = (currentScrollY / maxScroll) * 100;

            setScrollPosition({
                x: currentScrollX,
                y: currentScrollY,
                direction,
            });

            setScrollProgress(Math.min(100, Math.max(0, progress)));
            setIsScrolling(true);

            clearTimeout(scrollTimeout);

            scrollTimeout = setTimeout(() => {
                setIsScrolling(false);
            }, 150);

            lastScrollY = currentScrollY;
            ticking = false;
        };

        const handleScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(updateScrollPosition);
                ticking = true;
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            clearTimeout(scrollTimeout);
        };
    }, []);

    return { scrollPosition, isScrolling, scrollProgress };
};